import { render, staticRenderFns } from "./all-token-calls.vue?vue&type=template&id=23ec54f2&"
import script from "./all-token-calls.vue?vue&type=script&lang=js&"
export * from "./all-token-calls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports